define('app/views/location_map_view',['app/setup', 'async'], function(takhfifan) {
  takhfifan.LocationMapView = Backbone.View.extend({
    initialize: function() {
      this.loadMap();
      this.markers = [];
    },

    loadMap: function() {
      $('.location-page-map').css("background", "none");
      var map;
      map = new L.Map('tmap');
      var osmUrl='https://{s}.maps.takhfifan.com/hot/{z}/{x}/{y}.png';
      var osmAttrib='';
      var osm = new L.TileLayer(osmUrl, {minZoom: 0, maxZoom: 16, attribution: osmAttrib});
      map.addLayer(osm);
      map.setView(new L.LatLng(35.6967329, 51.2097322), 3);
      this.map = map;

      var _this = this;
      takhfifan.eventHub.on('location:updateMap', function(opts) {
        if(!opts || !opts.length) {
          return
        }
        _this.updateMap(opts);
      });
    },
    updateMap: function(products) {
      if (typeof this.map == 'undefined' || products == 'undefined' || products.length <= 0) {
        return;
      }

      for (var i = 0; i < this.markers.length; i++) {
        this.map.removeLayer(this.markers[i]);
      }

      this.markers = [];
      
      var markerIcons = {
        'c-food' : 'restaurant.svg',
        'c-theatre' : 'theater.svg',
        'c-sport' : 'entertainment.svg',
        'c-learn' : 'education.svg',
        'c-medical' : 'health.svg',
        'c-beauty' : 'beauty.svg',
        'c-travel' : 'travel.svg',
        'c-product': 'kala.svg',
      };

      var markerIconsBasePath = '/skin/frontend/v3/default/images/map/';
      for(i = 0; i < products.length; i++ ) {
        var p = products[i];
        var icon = L.icon({
          iconUrl: markerIconsBasePath + markerIcons[p.categoryIcon],
          iconSize: [40, 60],
          iconAnchor: [20, 60],
          popupAnchor: [0, -60]
        });
        var marker = L.marker(
          [ p['latitude'], p['longitude'] ],
          { icon: icon }
        ).addTo(this.map);

        var popupContent = '<div id="iw-container">' +
          '<div class="iw-content clear" style="direction: rtl;">' +
          '<img src="' + p['imgUrl'] + '" alt="" height="160" width="250">' +
          '<span class="iw-subTitle number-font">' + p['title'] + '</span>' +
          '<div class="clear"></div>' +
          '<span class="final-price number-font"><b class="number-font">' + p['price'] + '</b> تومان</span>' +
          '<a href="' + p['url'] + '" class="btn btn-green" style="color: #fff;">' +
          '<img src="/skin/frontend/v3/default/images/coupon_icon.svg" class="coupon-icon" width="20px"><span>خرید</span></a>' +
          '</div>' +
          '</div>';

        marker.bindPopup(popupContent);
        this.markers.push(marker);
      }

      var group = L.featureGroup(this.markers);
      this.map.fitBounds(group.getBounds());
    }
  });
});

